module.exports = __webpack_public_path__ + "img/icon_NCDs_A02_bf.dd0abd5f.png";